import subscriptionSaved from '@ori-events/subscription-saved';
import { useCallback } from 'react';

export function useSaveEvent() {
  const handleSave = useCallback((...data: Parameters<typeof subscriptionSaved.dispatch>) => {
    subscriptionSaved.dispatch(...data);
  }, []);

  return { handleSave } as const;
}
